import React from 'react'
import {commonStyleObj} from '../utils/utils'

class UserComponent extends React.Component {
    constructor(props){
        super(props);
        this.state={
            name: 'Guest',
            age: 20
        }
    }

    componentDidMount(){
        console.log("ComponentDidMount called")
    }

    componentDidUpdate(){
        console.log("ComponentDidUpdate called")
    }

    componentWillUnmount(){
        console.log("ComponentWillUnmount called")
    }

    render(){
        return <div>
            <h3> I am a class component </h3>
            <p> User Name : {this.state.name} </p>
            <p> User Age : {this.state.age} </p>
            <button onClick={() => this.setState({...this.state, name: 'Apurv', age: 25})}>
                update state
            </button>
        </div>
    }
}

function CustomerComponent (){
    const [customer, setCustomer] = React.useState("Guest")

    React.useEffect(() => {
        console.log("useEffect callback function called")
        return () => console.log('useEffect cleanup function called')
    },[customer]) 

    const handleClick = () => {
        setCustomer('Apurv')
    }

    return <div>
        <h3> I am a Functional component </h3>
        <p> Customer Name : {customer} </p>
        <button 
        onClick={handleClick}
        >
        update State
        </button>
        </div>
}

const LifecyleMethods = () => {

    const [classComp, setClassComp] = React.useState(false)
    const [funcComp, setFuncComp] = React.useState(false)

    return<div style={commonStyleObj}>
            <h3>Lifecyle Methods and useEffect Demo</h3>
            <p style={{ padding: '0px 100px' }}>First open up the console,
            toggle class component and then update the state and toggle it back again.
            Then do the same for functional component</p>
            <button onClick={() => setClassComp(classComp => !classComp)}>toggle class component</button>
            <button onClick={() => setFuncComp(funcComp => !funcComp)}>toggle functional component</button>
            {classComp && <UserComponent/>}
            {funcComp && <CustomerComponent/>}
        </div>
}

export default LifecyleMethods